/* eslint-disable @typescript-eslint/ban-ts-comment */
import Keycloak, { KeycloakConfig } from "keycloak-js";
import appInsights from './index';
import {
  AuthClientInitOptions,
  AuthClientEvent,
  AuthClientError,
} from "@react-keycloak/core/lib/types";

const keycloakConfig: KeycloakConfig = {
  // @ts-ignore
  url: window._env_.REACT_APP_KEYCLOAK_URL,
  realm: "apoportal-realm",
  // @ts-ignore
  clientId: window._env_.REACT_APP_KEYCLOAK_CLIENT_ID as string,
};

export const keycloakInitOptions: AuthClientInitOptions | undefined = {};

export const keycloak = new Keycloak(keycloakConfig);

export const keycloakOnEvent = (
  event: AuthClientEvent,
  error?: AuthClientError
) => {
  switch (event) {
    case "onAuthSuccess":
      if (keycloak.authenticated && keycloak.tokenParsed) {
        const userId = keycloak.tokenParsed.sub || keycloak.tokenParsed.preferred_username;
        const accountId = keycloak.tokenParsed.preferred_username || keycloak.tokenParsed.email;
        appInsights.setAuthenticatedUserContext(userId, accountId, true);
        appInsights.trackEvent({ name: "ApoPortalSuccessfullUserLogin" }, { loginTime: new Date().toISOString() });
      }
      break;
    case "onTokenExpired":
      keycloak.updateToken(30).catch(() => {
        console.error("TOKEN REFRESH FAILED" + error);
      });
      break;
    default:
      break;
  }
};
